import styled from 'styled-components';

export const IncomeOverviewContainer = styled.div`
    width: 25rem;
`;
